import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess } from "@/store/Crud/functions/getters";

function getBaseBook(state: State): any {
  return state.baseKnowledgeBook;
}

function getAdditionalBookA(state: State): any {
  return state.additionalKnowledgeBookA;
}

function getAdditionalBookB(state: State): any {
  return state.additionalKnowledgeBookB;
}

function getBaseBookPage(state: State): any {
  return state.baseHtmlPage;
}

function getAdditionalBookAPage(state: State): any {
  return state.additionalBookAHtmlPage;
}

function getAdditionalBookBPage(state: State): any {
  return state.additionalBookBHtmlPage;
}

function getIsPageLoading(state: State): boolean {
  return state.pageLoading;
}

export default <GetterTree<State, any>>{
  getIsLoading,
  getSuccess,
  getError,
  getDataItem,
  getBaseBook,
  getAdditionalBookA,
  getAdditionalBookB,
  getIsPageLoading,
  getBaseBookPage,
  getAdditionalBookAPage,
  getAdditionalBookBPage,
};
